export var SwapStatusEnumKeys;
(function (SwapStatusEnumKeys) {
    SwapStatusEnumKeys["DRAFT"] = "DRAFT";
    SwapStatusEnumKeys["DEPOSIT_PENDING"] = "DEPOSIT_PENDING";
    SwapStatusEnumKeys["DEPOSIT_CONFIRMED"] = "DEPOSIT_CONFIRMED";
    SwapStatusEnumKeys["DEPOSIT_FAILED"] = "DEPOSIT_FAILED";
    SwapStatusEnumKeys["EXCHANGE_IN_PROGRESS"] = "EXCHANGE_IN_PROGRESS";
    SwapStatusEnumKeys["EXCHANGE_COMPLETED"] = "EXCHANGE_COMPLETED";
    SwapStatusEnumKeys["EXCHANGE_FAILED"] = "EXCHANGE_FAILED";
    SwapStatusEnumKeys["WITHDRAW_IN_PROGRESS"] = "WITHDRAW_IN_PROGRESS";
    SwapStatusEnumKeys["WITHDRAW_COMPLETED"] = "WITHDRAW_COMPLETED";
    SwapStatusEnumKeys["WITHDRAW_FAILED"] = "WITHDRAW_FAILED";
})(SwapStatusEnumKeys || (SwapStatusEnumKeys = {}));
export var TransactionModeEnum;
(function (TransactionModeEnum) {
    TransactionModeEnum["SWAP"] = "SWAP";
    TransactionModeEnum["STANDALONE"] = "STANDALONE";
})(TransactionModeEnum || (TransactionModeEnum = {}));
export const SWAP_INFO_POOL_INTERVAL = 15000;
export var SwapTaskStatusEnum;
(function (SwapTaskStatusEnum) {
    SwapTaskStatusEnum["ACTIVE"] = "ACTIVE";
    SwapTaskStatusEnum["CANCELED"] = "CANCELED";
    SwapTaskStatusEnum["COMPLETED"] = "COMPLETED";
    SwapTaskStatusEnum["DRAFT"] = "DRAFT";
})(SwapTaskStatusEnum || (SwapTaskStatusEnum = {}));
// Tranche-related types
// Note: Values must match GraphQL enum serialization (uses enum KEYS, not values)
export var SwapLiquidationTrancheStatusEnum;
(function (SwapLiquidationTrancheStatusEnum) {
    SwapLiquidationTrancheStatusEnum["PENDING"] = "PENDING";
    SwapLiquidationTrancheStatusEnum["PROCESSING"] = "PROCESSING";
    SwapLiquidationTrancheStatusEnum["DEPOSIT_REBALANCING_PENDING"] = "DEPOSIT_REBALANCING_PENDING";
    SwapLiquidationTrancheStatusEnum["DEPOSIT_REBALANCING_CONFIRMED"] = "DEPOSIT_REBALANCING_CONFIRMED";
    SwapLiquidationTrancheStatusEnum["DEPOSIT_REBALANCING_FAILED"] = "DEPOSIT_REBALANCING_FAILED";
    SwapLiquidationTrancheStatusEnum["LIQUIDATION_PENDING"] = "LIQUIDATION_PENDING";
    SwapLiquidationTrancheStatusEnum["LIQUIDATION_CONFIRMED"] = "LIQUIDATION_CONFIRMED";
    SwapLiquidationTrancheStatusEnum["LIQUIDATION_FAILED"] = "LIQUIDATION_FAILED";
    SwapLiquidationTrancheStatusEnum["WITHDRAW_REBALANCING_PENDING"] = "WITHDRAW_REBALANCING_PENDING";
    SwapLiquidationTrancheStatusEnum["WITHDRAW_REBALANCING_CONFIRMED"] = "WITHDRAW_REBALANCING_CONFIRMED";
    SwapLiquidationTrancheStatusEnum["WITHDRAW_REBALANCING_FAILED"] = "WITHDRAW_REBALANCING_FAILED";
    SwapLiquidationTrancheStatusEnum["COMPLETED"] = "COMPLETED";
    SwapLiquidationTrancheStatusEnum["FAILED"] = "FAILED";
    SwapLiquidationTrancheStatusEnum["PAUSED"] = "PAUSED";
    SwapLiquidationTrancheStatusEnum["PENDING_MANUAL_RETRY"] = "PENDING_MANUAL_RETRY";
})(SwapLiquidationTrancheStatusEnum || (SwapLiquidationTrancheStatusEnum = {}));
// Event-related types
export var SwapEventTypeEnum;
(function (SwapEventTypeEnum) {
    SwapEventTypeEnum["CREATED"] = "created";
    SwapEventTypeEnum["STATUS_CHANGED"] = "status_changed";
    SwapEventTypeEnum["AUTO_RETRY_ATTEMPTED"] = "auto_retry_attempted";
    SwapEventTypeEnum["AUTO_RETRY_EXHAUSTED"] = "auto_retry_exhausted";
    SwapEventTypeEnum["MANUAL_RETRY_REQUESTED"] = "manual_retry_requested";
    SwapEventTypeEnum["PAUSED"] = "paused";
    SwapEventTypeEnum["RESUMED"] = "resumed";
    SwapEventTypeEnum["CANCELLED"] = "cancelled";
    SwapEventTypeEnum["FORCE_COMPLETED"] = "force_completed";
    SwapEventTypeEnum["RESERVATION_CREATED"] = "reservation_created";
    SwapEventTypeEnum["RESERVATION_CONFIRMED"] = "reservation_confirmed";
    SwapEventTypeEnum["RESERVATION_CONSUMED"] = "reservation_consumed";
    SwapEventTypeEnum["RESERVATION_RELEASED"] = "reservation_released";
    SwapEventTypeEnum["RESERVATION_EXPIRED"] = "reservation_expired";
    SwapEventTypeEnum["RESERVATION_HELD"] = "reservation_held";
    SwapEventTypeEnum["ORDER_PLACED"] = "order_placed";
    SwapEventTypeEnum["ORDER_FILLED"] = "order_filled";
    SwapEventTypeEnum["ORDER_FAILED"] = "order_failed";
    SwapEventTypeEnum["DEPOSIT_REBALANCING_COMPLETED"] = "deposit_rebalancing_completed";
    SwapEventTypeEnum["DEPOSIT_DETECTED"] = "deposit_detected";
    SwapEventTypeEnum["DEPOSIT_CONFIRMED"] = "deposit_confirmed";
    SwapEventTypeEnum["DEPOSIT_FAILED"] = "deposit_failed";
    SwapEventTypeEnum["ADMIN_NOTE_ADDED"] = "admin_note_added";
})(SwapEventTypeEnum || (SwapEventTypeEnum = {}));
export var SwapEventEntityTypeEnum;
(function (SwapEventEntityTypeEnum) {
    SwapEventEntityTypeEnum["SWAP"] = "swap";
    SwapEventEntityTypeEnum["TRANCHE"] = "tranche";
    SwapEventEntityTypeEnum["RESERVATION"] = "reservation";
})(SwapEventEntityTypeEnum || (SwapEventEntityTypeEnum = {}));
export var SwapEventTriggeredByEnum;
(function (SwapEventTriggeredByEnum) {
    SwapEventTriggeredByEnum["SYSTEM"] = "system";
    SwapEventTriggeredByEnum["ADMIN"] = "admin";
    SwapEventTriggeredByEnum["SCHEDULER"] = "scheduler";
})(SwapEventTriggeredByEnum || (SwapEventTriggeredByEnum = {}));
// Reservation-related types
export var SwapBalanceReservationStatusEnum;
(function (SwapBalanceReservationStatusEnum) {
    SwapBalanceReservationStatusEnum["PENDING"] = "PENDING";
    SwapBalanceReservationStatusEnum["CONFIRMED"] = "CONFIRMED";
    SwapBalanceReservationStatusEnum["CONSUMED"] = "CONSUMED";
    SwapBalanceReservationStatusEnum["RELEASED"] = "RELEASED";
    SwapBalanceReservationStatusEnum["EXPIRED"] = "EXPIRED";
    SwapBalanceReservationStatusEnum["HELD"] = "HELD";
})(SwapBalanceReservationStatusEnum || (SwapBalanceReservationStatusEnum = {}));
//# sourceMappingURL=swap.js.map